/*
 * @Author: 姚阳子 yaoyangzi@linhuiba.com
 * @Date: 2023-05-12 10:47:15
 * @LastEditors: 姚阳子 yaoyangzi@linhuiba.com
 * @LastEditTime: 2023-05-12 15:31:32
 * @FilePath: /locationpms-pc/src/router/crm/user.ts
 * @Description: 悟空crm用户中心路由
 *
 */
/** 个人中西管理路由 */
var personRouter = {
    path: '/person',
    name: 'person',
    hidden: true,
    meta: {
        title: '个人中心'
    },
    component: function () { return import('@/wkcrmViews/user/index.vue'); }
};
export default personRouter;
